/* Open Road — close header dropdowns on the way out.
 *
 * Dawn's DetailsDisclosure only closes a <details> menu on `focusout`, which
 * covers keyboard users but not mice: click the Services item, move the
 * pointer away, and the panel just stays open until you click the summary
 * again.
 *
 * This adds the three exits a pointer user expects — leaving the menu,
 * clicking elsewhere, and Escape — without touching Dawn's own file, so the
 * theme's upgrade path stays clean. Keyboard behaviour is left entirely to
 * Dawn; nothing here fires on focus.
 *
 * Progressive enhancement: with JS off the menus still open and close by
 * clicking the summary, which is native <details> behaviour.
 */
(function () {
  'use strict';

  /* Long enough to forgive a diagonal path across a gap between the summary
     and the panel, short enough not to feel stuck. */
  var GRACE_MS = 220;

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu details, header-menu details');
    if (!menus.length) return;

    Array.prototype.forEach.call(menus, function (details) {
      var timer = null;

      function close() {
        if (!details.hasAttribute('open')) return;
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      function cancelClose() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      details.addEventListener('pointerleave', function (event) {
        /* Touch and pen do not have a meaningful "leave" — closing on them
           would shut the menu the instant it opened. Mouse only. */
        if (event.pointerType && event.pointerType !== 'mouse') return;
        cancelClose();
        timer = setTimeout(close, GRACE_MS);
      });

      details.addEventListener('pointerenter', cancelClose);

      /* If focus is inside, the user is driving by keyboard — do not yank the
         panel away underneath them. Dawn's focusout handles that case. */
      details.addEventListener('pointerleave', function () {
        if (details.contains(document.activeElement)) cancelClose();
      });
    });

    document.addEventListener('click', function (event) {
      Array.prototype.forEach.call(menus, function (details) {
        if (details.hasAttribute('open') && !details.contains(event.target)) {
          details.removeAttribute('open');
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      Array.prototype.forEach.call(menus, function (details) {
        if (!details.hasAttribute('open')) return;
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
